import TableCell from '@tiptap/extension-table-cell';
import { CellSelection } from 'prosemirror-tables';
import { ReactNodeViewRenderer } from '@tiptap/react'


const CustomTableCell = TableCell.extend({
    addCommands() {
        return {
            selectRow: cell => ({ tr: transaction, dispatch }) => {
                if (dispatch) {
                    const position = transaction.doc.resolve(cell);
                    const rowSelection = CellSelection.rowSelection(position);
                    transaction.setSelection(rowSelection);
                }
                return true;
            },
            selectColumn: cell => ({ tr: transaction, dispatch }) => {
                if (dispatch) {
                    const position = transaction.doc.resolve(cell);
                    const colSelection = CellSelection.colSelection(position);
                    transaction.setSelection(colSelection);
                }
                return true;
            }
        };
    }
});

export { CustomTableCell, CustomTableCell as default };